var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-simple-select" }, [
    _c(
      "div",
      [
        _c(
          "div",
          {
            on: {
              click: function($event) {
                _vm.open = true
              },
              blur: function($event) {
                _vm.open = false
              }
            }
          },
          [
            _c("div", [
              _c("p", { staticClass: "mb-0" }, [
                _vm.selected != null
                  ? _c("b", [_c("span", [_vm._v(_vm._s(_vm.selected))])])
                  : _c("b", [
                      _vm._v(_vm._s(_vm.def ? _vm.def : _vm.placeholder))
                    ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "dropdown" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.open,
                  expression: "open"
                }
              ],
              staticClass: "dropdown-list"
            },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  attrs: { value: item },
                  on: {
                    click: function($event) {
                      return _vm.onClick(item)
                    }
                  }
                },
                [_c("span", [_vm._v(_vm._s(item))])]
              )
            }),
            0
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76e1c86e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e1c86e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/CustomSimpleSelect.vue
// module id = null
// module chunks = 